import { cloneDeep } from 'lodash';
import * as types from '../mutation-types';
import Vue from 'vue';
import edtDate from '@/helpers/edt-date';

const initialState = {
  currentLanguage: '',
  isProcessing: true,
  stompConfig: {
    actionsOutboundQueue: '',
    brokerPassword: '',
    brokerUrl: '',
    brokerUsername: '',
    updatesInboundTopic: '',
  },
  stompState: {
    client: null,
    connect: null,
    subscriptions: {
      all: null,
      ingame: null,
      personal: null,
    },
  },
  gameState: {
    activeGame: null,
    activeDuel: null,
  },
  predictionsTypes: null,
  games: null,
  currentDuel: null,
  currentGame: null,
  connection: null,
  connectionModalInstance: null,
};

const mutations = {
  [types.APP_SET_CURRENT_LANGUAGE](state, payload) {
    state.currentLanguage = payload;
  },
  [types.APP_TOGGLE_PROCESSING](state, payload) {
    state.isProcessing =
      typeof payload === 'boolean' ? payload : !state.isProcessing;
  },
  [types.APP_SET_STOMP_CONFIG](state, payload) {
    state.stompConfig.actionsOutboundQueue = payload.actionsOutboundQueue;

    state.stompConfig.brokerUrl = payload.brokerUrl;
    state.stompConfig.brokerUsername = payload.brokerUsername;
    state.stompConfig.brokerPassword = payload.brokerPassword;

    state.stompConfig.updatesInboundTopic = payload.updatesInboundTopic;
    state.stompConfig.broadcastUpdatesInboundTopic =
      payload.broadcastUpdatesInboundTopic;
    state.stompConfig.personalUpdatesInboundTopic =
      payload.personalUpdatesInboundTopic;
  },
  [types.APP_SET_GAME_STATE](state, payload) {
    state.gameState = payload;
  },
  [types.APP_RESET_GAME_STATE](state) {
    state.gameState = cloneDeep(initialState.gameState);
  },
  [types.APP_CLOSE_PREDICTIONS](state, competitionId) {
    state.gameState.activeGame.currentInning.competitions.find(
      ({ id }) => id === competitionId
    ).status = 'CLOSED';
  },
  [types.APP_START_PREDICTIONS](state, competition) {
    state.gameState.activeGame.currentInning.competitions.push(competition);
  },
  [types.APP_POST_RESULTS](state, competition) {
    const targetCompetition = state.gameState.activeGame.currentInning.competitions.find(
      ({ id }) => id === competition.id
    );
    targetCompetition.result = competition.result;
    targetCompetition.status = 'CLOSED';
  },
  [types.APP_NEXT_COMPETITION](state, competitionId) {
    state.gameState.activeGame.currentInning.competitions.find(
      ({ id }) => id === competitionId
    ).status = 'DONE';
  },
  [types.APP_CANCEL_RESULTS](state, competitionId) {
    state.gameState.activeGame.currentInning.competitions.find(
      ({ id }) => id === competitionId
    ).result = null;
  },
  [types.APP_END_HALF_INNING](state, game) {
    state.gameState.activeGame.currentInning = game.currentInning;
    state.gameState.activeGame.innings = game.innings;
  },
  [types.APP_SET_PREDICTIONS_TYPES](state, types) {
    state.predictionsTypes = types;
  },
  [types.APP_SET_GAMES](state, games) {
    state.games = games.slice();
  },
  [types.APP_UPDATE_GAME](state, game) {
    const gameIndex = state.games.findIndex(({ id }) => +id === game.id);

    if (gameIndex > -1) {
      if (game.active === false) {
        state.games.splice(gameIndex, 1);
      } else {
        Vue.set(state.games, gameIndex, game);
      }
      return;
    }

    const dateRaw = edtDate(new Date(), 'raw');
    dateRaw.setHours(12, 0, 0, 0);
    const gameDateRaw = edtDate(game.startDate, 'raw');

    const diffMs = Math.abs(dateRaw.getTime() - gameDateRaw.getTime());
    const diffHours = diffMs / (1000 * 60 * 60);

    if (diffHours <= 36) {
      state.games.push(game);
    }
  },
  [types.APP_SET_STOMP_STATE](state, { client, connect, subscriptions }) {
    state.stompState.client = client;
    state.stompState.connect = connect;
    state.stompState.subscriptions.all = subscriptions.all;
    state.stompState.subscriptions.personal = subscriptions.personal;
    state.stompState.subscriptions.ingame = subscriptions.ingame;
  },
  [types.APP_SET_STOMP_SUBSCRIPTION](state, { name, value }) {
    state.stompState.subscriptions[name] = value;
  },
  [types.APP_SET_DUEL_PAGE_DATA](state, { duel, game }) {
    state.duelPag;
  },
  [types.APP_STOMP_DEACTIVATE](state) {
    state.stompState.client.deactivate();
  },
  [types.APP_SET_CONNECTION_STATUS](state, status) {
    state.connection = status;
  },
  [types.APP_SET_OFFLINE_MODAL_INSTANCE](state, payload) {
    state.connectionModalInstance = payload;
  },
};

export default {
  state: cloneDeep(initialState),
  mutations,
};
